import React, { useEffect, useRef } from "react"
import { NavLink, useLocation, useNavigate } from "react-router-dom"
import { useAuthContext } from "contexts/AuthContext"
import { changeMenu, menuOpen } from "utils/sounds"
import useSound from "use-sound"
import { professorRoutes as routes } from "common/navigationRoutes"
import { HeaderUI } from "./Header.ui"
import Image from "components/Image"

export const ProfessorHeaderView = ({ onMenuClick = () => {} }) => {
  const navigate = useNavigate()
  const location = useLocation()
  const currentRoute = location.pathname
  const { userData, updateUserData, logout } = useAuthContext()
  const firstLoadRef = useRef(true)
  const [playMenuSound] = useSound(menuOpen, { volume: 0.5, html5: false })
  const [playChangeMenuSound] = useSound(changeMenu, {
    volume: 0.5,
    html5: false,
  })

  useEffect(() => {
    firstLoadRef.current = true
    return () => {
      firstLoadRef.current = false
    }
  }, [])

  const changeTutorialsPreference = (evt) => {
    evt.stopPropagation()
    updateUserData({
      newUserData: {
        allowTutorials: !userData?.allowTutorials,
      },
    })
  }

  const changeAudioEffectsPreference = (evt) => {
    evt.stopPropagation()
    updateUserData({
      newUserData: {
        allowSoundEffects: !userData?.allowSoundEffects,
      },
    })
  }

  const changeDarkModePreference = (evt) => {
    const isDarkMode = userData?.uiSettings?.theme?.toLowerCase() === "dark"
    evt.stopPropagation()
    updateUserData({
      newUserData: {
        uiSettings: {
          theme: isDarkMode ? "Light" : "Dark",
        },
      },
    })
    localStorage.setItem("smash-prefers-dark-mode", (!isDarkMode).toString())
    if (window.applyDarkMode) {
      window.applyDarkMode()
    }
  }

  const handleMenuClick = () => {
    playMenuSound()
    onMenuClick()
  }

  const handleNavLinkClick = (event, menu) => {
    if (currentRoute === menu.path) {
      event.preventDefault()
      playChangeMenuSound()
      navigate(0)
      return
    }
    playChangeMenuSound()
  }

  return (
    <HeaderUI
      currentRoute={currentRoute}
      userData={userData}
      onOpenDrawer={handleMenuClick}
      onNavLinkClick={handleNavLinkClick}
      pagesLeft={[]}
      pagesRight={[]}
      centerContent={
        <NavLink
          to={routes.PROFESSOR_MISSIONS}
          onClick={(e) =>
            handleNavLinkClick(e, { path: routes.PROFESSOR_MISSIONS })
          }
        >
          <Image name="logoAppBar" width={"50px"} height={"auto"} />
        </NavLink>
      }
      userLeftContent={null}
      userRightContent={null}
      onTutorialsChanged={changeTutorialsPreference}
      onAudioEffectsChanged={changeAudioEffectsPreference}
      onDarkModeChanged={changeDarkModePreference}
      onLogout={logout}
      onSettingsClick={() => {
        navigate(routes.PROFESSOR_ACCOUNT)
      }}
    />
  )
}
